import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import Key              from "../../../types/Key"
import KeyTimeLimitData from "@customTypes/KeyTimeLimitData"

export interface props {
    item: Key
}

const ItemGroupKeyTimeLimit: React.FC<props> = ({item}) => {

    const {t} = useTranslation()

    if (! item.keyTimeLimits) {
        return (<div></div>)
    }

    const weekDays: string[] = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
    ];

    return (
        <IonItemGroup className="ion-margin-top">
            <IonItemDivider>
                {t('time-limits.time_limits_for_keys')}
            </IonItemDivider>
            {item.keyTimeLimits?.keyTimeLimitSlots?.map((keyTimeLimitSlot, keyTimeLimitSlotIndex) => {

                if (keyTimeLimitSlot.slotNo === 0) {
                    return (
                        <IonItem key={keyTimeLimitSlotIndex} lines="full">
                            <IonLabel>
                                {t('common.from')}
                            </IonLabel>
                            <IonNote className="ion-padding-vertical" slot="end">
                                {keyTimeLimitSlot.date}
                            </IonNote>
                        </IonItem>
                    )
                } else if (keyTimeLimitSlot.slotNo === 1) {
                    return (
                        <IonItem key={keyTimeLimitSlotIndex} lines="full">
                            <IonLabel>
                                {t('common.until')}
                            </IonLabel>
                            <IonNote className="ion-padding-vertical" slot="end">
                                {keyTimeLimitSlot.date}
                            </IonNote>
                        </IonItem>
                    )
                } else if (keyTimeLimitSlot.slotNo === 2) {
                    return (
                        <IonItem key={keyTimeLimitSlotIndex} lines="full">
                            <IonLabel>
                                <h2>{keyTimeLimitSlot.timeLimit?.name || '(tijdsprofiel naam)'}</h2>
                                {(keyTimeLimitSlot.timeLimitStartDate || keyTimeLimitSlot.timeLimitEndDate) && (
                                    <span style={{ 'color': '#777' }}>
                                        {t('common.from')}:  {keyTimeLimitSlot.timeLimitStartDate}<br />
                                        {t('common.until')}: {keyTimeLimitSlot.timeLimitEndDate}
                                    </span>
                                )}

                                {keyTimeLimitSlot?.keyTimeLimitData?.map((keyTimeLimitData, keyTimeLimitDataIndex) => {

                                    const itemWeekDays = weekDays.filter(
                                        (weekDay: string) => {
                                            return keyTimeLimitData['weekDay' + weekDay as keyof KeyTimeLimitData] as boolean
                                        }).map(weekDay => t('common.weekDays.' + weekDay).substring(0, 2))

                                    return (
                                        <div key={keyTimeLimitDataIndex} style={{ 'color': '#777'}}>
                                            <h3>
                                                {keyTimeLimitData.startTime} - {keyTimeLimitData.endTime}
                                            </h3>
                                            <h4>
                                                {itemWeekDays.join(', ')}<br />
                                            </h4>
                                        </div>
                                    )
                                })}
                            </IonLabel>
                        </IonItem>
                    )
                }

                return (
                    <IonItem key={keyTimeLimitSlotIndex} lines="full">
                        <IonLabel>
                            unknown time limit slot
                        </IonLabel>
                        <IonNote className="ion-padding-vertical" slot="end">
                            ?
                        </IonNote>
                    </IonItem>
                )
            })}
        </IonItemGroup>
    )
}

export default ItemGroupKeyTimeLimit